<template>
    <div>
        <!-- 搜索框 -->
        <a-card title="角色管理">
            <a-button slot="extra" type="primary" @click="handleNewRole">新建角色</a-button>
            <a-form layout="inline" @submit="handleSubmit" :form="form">
                <a-form-item label="选择平台">
                    <a-select v-model="searchP.platfromcode" style="width:160px;" placeholder="请选择" @change="handleSubmit">
                        <a-select-option v-for="(item) in platformlist" :key="item.platfromcode"
                                         v-model="item.platfromcode">
                            {{ item.platfromname + '【' + item.platfromcode + '】' }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="角色名称">
                    <a-input v-model="searchP.rolename" placeholder="请输入角色名称"></a-input>
                </a-form-item>
                <a-form-item label="状态">
                    <a-select v-model="searchP.status" placeholder="" style="width:100px;">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option value="1">使用</a-select-option>
                        <a-select-option value="0">禁用</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>

        <!-- 系统列表 -->
        <a-table :columns="columns" :data-source="data" :pagination="false" :loading="tLoading" rowKey="id">
            <span slot="status" slot-scope="text">{{ ['禁用', '使用'][text] }}</span>
            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <span><router-link :to="{path:'editrole',query: {id: record.id}}">编辑</router-link></span>

                    <span v-if="searchP.platfromcode == 'FP'"><router-link :to="{path:'authrole',query: {id: record.id}}">系统授权</router-link></span>

                </div>
            </template>
        </a-table>

        <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange"
                      show-less-items show-quick-jumper/>


    </div>
</template>
<script>
let searchP ={
    rolename: '',//用户姓名
    total: 0,
    pageSize: 0,
    platfromcode: 'FP',
    page: undefined,
};
const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = searchP;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: '角色名称',
        dataIndex: 'rolename',
        align: 'center',
        width: 120,
        ellipsises: true
    },
    {
        title: '角色编码',
        dataIndex: 'rolecode',
        align: 'center',
        width: 200
    },
    
    {
        title: '平台编码',
        dataIndex: 'platfromcode',
        align: 'center',
        width: 120,
        ellipsises: true
    },
    {
        title: '状态',
        dataIndex: 'status',
        scopedSlots: {customRender: 'status'},
        align: 'center',
        width: 120,
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width:100,
        scopedSlots: {customRender: 'operation'},
    }

];
const data = [];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            searchP,
            tLoading: true,
            platformlist: [],
        };
    },
    methods: {
        getSearchPlatFromConfig() {
            let c_params = {
                urlparams: false,
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: "ums/selectPlatFromConfig",
                params: c_params
            }).then((res) => {
                console.log(res);
                this.platformlist = res.data.data;
                this.getRoleList();

            })
        },
        getRoleList() {
            let c_params = {
                ...this.searchP,
                urlparams: false,
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: "ums/searchRoleConfigPage",
                params: c_params
            }).then((res) => {
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                this.data = result.list;
                this.searchP.total = result.totalRecords;
                this.searchP.pageSize = result.pageSize;
                this.searchP.page = result.page;
            })
        },
        handlePageChange(c_p) {
            this.searchP.page = c_p;
            this.updateRoute();
        },
        updateRoute() {
            this.$router.push({
                query: {
                    rolename: this.searchP.rolename,
                    page: this.searchP.page,
                    platfromcode: this.searchP.platfromcode
                }
            });
        },
        handleSearchReset() {
            this.searchP.page = 1;
            this.searchP.rolename = '';
            this.searchP.platfromcode = '';
            this.updateRoute();
        },
        handleNewRole() {
            if (this.searchP.platfromcode == '') {
                alert("请选择平台")
                return false
            }

            this.$router.push({
                path: "addrole",
                query: {id: '', platfromcode: this.searchP.platfromcode}
            });
        },
        handleSubmit() {
            this.searchP.page = 1;
            this.updateRoute()
        },

    },

    components: {},
    watch: {
        '$route'() {
            this.$router.go(0);
        }
    },
    mounted() {
        let query = this.$route.query;
        this.searchP.rolename = query.rolename ? query.rolename : '';
        this.searchP.platfromcode = query.platfromcode ? query.platfromcode : 'FP';
        this.searchP.page = query.page ? +query.page : 1;
        this.getSearchPlatFromConfig();
    }
};
</script>
<style scoped>
.editable-row-operations a {
    margin-right: 8px;
}

td {
    padding: 10px 10px;
}
</style>
